import React from 'react'
import {
  CardContent,
  Container,
  StyledAreaLine
} from './CardWithAreaLine.styles'
import { HeightClass } from '~/utils/enum/classes'
import { LEVEL_DEFAULT } from '../HierarchyCard/HierarchyCard.data'
import {
  AlignmentOptions,
  AreaLineColorSchemes,
  AreaLineProps
} from '~/components/AreaLine/type'

export type CardWithAreaLineProps = {
  children: React.ReactNode
  heightClass: HeightClass
  headerColor?: AreaLineColorSchemes
  leftHeaderElement?: React.ReactElement
  centerHeaderElement?: React.ReactElement
  rightHeaderElement?: React.ReactElement
  cardContentProps?: React.HTMLAttributes<HTMLDivElement>
  hierarchyCardLevel?: number
  alignSecondPosition?: AlignmentOptions
  areaLineProps?: Partial<AreaLineProps> // TODO: Remover propriedades que dão shadow com essa
}

const CardWithAreaLine = ({
  children,
  heightClass,
  headerColor,
  leftHeaderElement,
  centerHeaderElement,
  rightHeaderElement,
  cardContentProps,
  hierarchyCardLevel = LEVEL_DEFAULT,
  alignSecondPosition = 'left',
  areaLineProps,
  ...containerProps
}: CardWithAreaLineProps & React.HTMLAttributes<HTMLDivElement>) => {
  const forwardAreaLineProps: AreaLineProps = {
    heightClass,
    colorScheme: headerColor,
    leftAreaElement: leftHeaderElement,
    centerAreaElement: centerHeaderElement,
    rightAreaElement: rightHeaderElement,
    alignment: alignSecondPosition,
    ...areaLineProps
  }

  return (
    <Container
      spacingClass={heightClass}
      level={hierarchyCardLevel}
      {...containerProps}
    >
      <StyledAreaLine minorGutter {...forwardAreaLineProps} />

      {children && (
        <CardContent heightClass={heightClass} {...cardContentProps}>
          {children}
        </CardContent>
      )}
    </Container>
  )
}

export default CardWithAreaLine
